import {DateTime} from "luxon";

export const handleDateChange = (cb) => (date: DateTime | null, minDate) => {
    if (date && date.isValid && date.diff(minDate ?? DateTime.fromISO("2000-01-01")).milliseconds > 0) {
        cb(date)
    }
};
